import React, { useRef } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";

function Contact({ isEnglish, theme }) {
  const form = useRef();

  // دالة الإرسال باستخدام EmailJS
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_4vo7z6u",       // Service ID
        "template_yukfi7l",      // Template ID
        form.current,
        "k5MH2oLWd1ly7oKNk"        // 🔁 بدّلها بمفتاحك الحقيقي من EmailJS
      )
      .then(
        (result) => {
          alert(isEnglish ? "Message sent successfully!" : "تم إرسال الرسالة بنجاح!");
          form.current.reset(); // تفريغ النموذج بعد الإرسال
        },
        (error) => {
          alert(isEnglish ? "Failed to send. Try again." : "فشل في الإرسال. حاول مرة أخرى.");
        }
      );
  };

  return (
    <div className={`contact ${theme}`} id="contact">
      <div className="right">
        <h2>{isEnglish ? "Get In Touch" : "تواصل معنا"}</h2>
        <p>
          {isEnglish
            ? "Have a project in mind or want to learn more about how we can help?\nFill out the form and we will get back to you as soon as possible"
            : "هل لديك مشروع في بالك أو تريد معرفة المزيد حول كيف يمكننا مساعدتك؟\nاملأ النموذج وسنعاود الاتصال بك في أقرب وقت ممكن"}
        </p>

        {/* البطاقات الثلاثة */}
        <div className="cards">
          <div className="card">
            <i className="fa-solid fa-pencil"></i>
            <h2>{isEnglish ? "Design Services" : "خدمات التصميم"}</h2>
            <p>
              {isEnglish
                ? "From branding to web design, we create visuals that capture attention and communicate your message"
                : "من الهوية البصرية إلى تصميم المواقع، نقدم تصاميم تجذب الانتباه وتنقل رسالتك بوضوح"}
            </p>
          </div>
          <div className="card">
            <i className="fa-solid fa-laptop"></i>
            <h2>{isEnglish ? "Development" : "البرمجة"}</h2>
            <p>
              {isEnglish
                ? "We build responsive, high-performance websites and applications tailored to your specific needs"
                : "نقوم ببناء مواقع وتطبيقات سريعة الاستجابة وعالية الأداء حسب متطلباتك الخاصة"}
            </p>
          </div>
          <div className="card">
            <i className="fa-solid fa-camera"></i>
            <h2>{isEnglish ? "Photography" : "التصوير"}</h2>
            <p>
              {isEnglish
                ? "Professional photography services to showcase your product, services and team"
                : "خدمات تصوير احترافية لعرض منتجاتك وخدماتك وفريقك بشكل مميز"}
            </p>
          </div>
        </div>
      </div>

      {/* نموذج التواصل */}
      <div className="left">
        <div className="contact-card">
          <h2>{isEnglish ? "Contact Us" : "راسلنا"}</h2>
          <form ref={form} onSubmit={sendEmail} id="contactForm">
            <div className="names">
              <div className="form-group">
                <label htmlFor="firstName">
                  {isEnglish ? "First Name" : "الاسم الأول"}
                </label>
                <input type="text" id="firstName" name="firstName" required />
              </div>
              <div className="form-group">
                <label htmlFor="lastName">
                  {isEnglish ? "Last Name" : "اسم العائلة"}
                </label>
                <input type="text" id="lastName" name="lastName" required />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">
                {isEnglish ? "Email" : "البريد الإلكتروني"}
              </label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-group">
              <label htmlFor="subject">
                {isEnglish ? "Subject" : "الموضوع"}
              </label>
              <input type="text" id="subject" name="subject" required />
            </div>
            <div className="form-group">
              <label htmlFor="message">
                {isEnglish ? "Message" : "الرسالة"}
              </label>
              <textarea id="message" name="message" required></textarea>
            </div>
            <div className="submit">
              <button type="submit" className="con">
                {isEnglish ? "Send Message" : "إرسال الرسالة"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
